import { validateRequiredForArray } from 'hb-react/shared/utils/validators/required';

export const validateSelectArray = ({ required, value }) => {
  let error;

  if (required) {
    error = validateRequiredForArray(value);
  }

  return error;
};
